import { createProviderToken } from '@recruitee/common';
import { RecentItemTransformer } from '@recruitee/dashboard-types';

export const { provide: provideRecentItem, inject: injectRecentItems } =
  createProviderToken<RecentItemTransformer>('recentItem')(true);
